module.exports = __webpack_public_path__ + "img/icon_left_msg.3becb756.svg";